import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { buildSubscriptionHref, STUDIO_RETURN_URL } from 'Pods/ThreeDStudio/Components/UsageModal/constants'

// threeDStudioAccessTier (Generator::SubscriptionState#tier) drives the CTA. Tiers
// whose users can already generate -- active subscription, free-beta trial, or
// spendable credits -- skip the payment form and go straight to the studio.
const CREATE_TIERS = ['subscribed', 'in_free_beta', 'has_credits']

function CTABanner({ subscriptionPaymentFormUrl = '' }) {
  // threeDStudioAccessTier and threeDStudioSubscriptionPaymentFormUrl are part of the
  // per-user payload flushed after /load-services.js (set in
  // has_fast_application_state_helpers.rb only when a user is signed in), so read them
  // from the full page config. Before that payload hydrates -- and for signed-out
  // visitors, who never get it -- the href falls back to the subscriptionPaymentFormUrl
  // SSR prop, which is the absolute (subdomain-qualified) URL in production so the CTA
  // does not 404 against the subscriptions-only payment-form route.
  const pageConfig = usePageConfig({ listener: 'full-page-config-loaded', checkIfAvailable: false })
  const tier = pageConfig?.threeDStudioAccessTier
  const paymentFormUrl = pageConfig?.threeDStudioSubscriptionPaymentFormUrl || subscriptionPaymentFormUrl

  let buttonLabel = 'Start Your Subscription'
  let buttonHref = buildSubscriptionHref(paymentFormUrl)

  if (CREATE_TIERS.includes(tier)) {
    buttonLabel = 'Start Creating with AI'
    buttonHref = STUDIO_RETURN_URL
  } else if (tier === 'eligible_for_trial') {
    buttonLabel = 'Try AI for Free'
    buttonHref = STUDIO_RETURN_URL
  }

  return (
    <section className="ai-sub-landing__cta-banner">
      <div className="ai-sub-landing__cta-banner-card">
        <div className="ai-sub-landing__cta-banner-content">
          <div className="ai-sub-landing__cta-banner-text">
            <h2 className="ai-sub-landing__cta-banner-title cgt-heading-500">Ready to Start Creating?</h2>
            <p className="ai-sub-landing__cta-banner-subtitle cgt-body-lg">
              Create custom 3D models with CGTrader AI, and access premium downloads anytime.
            </p>
          </div>
          <Button type="primary" href={buttonHref}>
            {buttonLabel}
          </Button>
        </div>
        <img
          className="ai-sub-landing__cta-banner-bird"
          src="/assets/ai_sub_landing/cta_banner/bird.webp"
          width={840}
          height={807}
          loading="lazy"
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  )
}

CTABanner.propTypes = {
  subscriptionPaymentFormUrl: string,
}

export default CTABanner
